import type { CalendarFilter, CalendarGridFilter } from '@tyro/api';

export const schoolCalendarKeys = {
  all: ['school-calendar'] as const,
  dayInfo: (filter: CalendarFilter) =>
    [...schoolCalendarKeys.all, 'dayInfo', filter] as const,
  gridInfo: (filter: CalendarGridFilter) =>
    [...schoolCalendarKeys.all, 'gridInfo', filter] as const,
};
